import { ITag } from '../../types';
import { IProgrammableTag, TagType } from 'api-paths-cas';

export { getAllTags, sortWIthIntakeFirst } from './getAllTags';
export { getTags } from './getTags';

export const createMultiIntakeTag = (summary: any) => {
  return {
    type: TagType.MULTI_INTAKE,
    id: `${summary.intakeId}#${summary.offerId}`,
    label: 'Intake',
    multiIntakeTagData: summary.intakes,
  };
};

export const getTagWithDescriptionAttached = (
  studentTag: ITag | IProgrammableTag,
  allUniTags: (ITag | IProgrammableTag)[],
) => {
  const tagFound = allUniTags.find((t: ITag) => t.id === studentTag.id);
  if (!tagFound) {
    return studentTag;
  }
  return {
    ...studentTag,
    description: tagFound.description,
  };
};
